import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { selectUserMustPickLocation } from "../User/userSelectors"
import { ChooseFirstLocationAdapter } from "./Components/ChooseFirstLocationAdapter"
import { Logger } from "shared/Helpers/logging"

export function usePickInitialLocation() {
    const logger = new Logger("location")
    const userMustPickLocation = useSelector(selectUserMustPickLocation)
    const [open, setOpen] = useState(userMustPickLocation)
    const [wasClosed, setWasClosed] = useState(false)

    logger.info(`User needs to pick initial location: ${userMustPickLocation}`)

    const handleClose = useCallback(() => {
        setWasClosed(true)
        setOpen(false)
    }, [setOpen, setWasClosed])

    const adapter = useCallback(
        () =>
            ChooseFirstLocationAdapter({
                userHasNoLocation: userMustPickLocation,
                open,
                onClose: handleClose,
            }),
        [open, userMustPickLocation, handleClose]
    )

    useEffect(() => {
        // During load this will change from false to true
        if (userMustPickLocation && !wasClosed) setOpen(true)
    }, [userMustPickLocation])

    return {
        PickInitialLocation: adapter
    }
}
